(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["STX"] = factory();
	else
		root["STX"] = root["STX"] || {}, root["STX"]["AvailabilityCalendar"] = factory();
})(self, () => {
return 